import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { AppBar, Tabs, Tab, Typography, Box, List } from '@mui/material';
import { useFirestore, useFirestoreCollectionData } from 'reactfire';
import { collection } from 'firebase/firestore';
import OrdersContext from '../Context/Orders/OrdersContext';
import OrderListItem from '../Components/OrderListItem/OrderListItem';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <List disablePadding>{children}</List>}
		</div>
	);
}

TabPanel.propTypes = {
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

export default function OrdersHistory() {
	const [value, setValue] = React.useState(0);
	const { orders, filterOption, filterOrderNav, onChangeFilterOrderNav } =
		useContext(OrdersContext);

	const deletedOrdersRef = collection(useFirestore(), 'deletedOrders');

	const { data: deletedData } = useFirestoreCollectionData(deletedOrdersRef, {
		idField: 'id',
	});

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: '100%' }}>
			<Box
				sx={{
					borderBottom: 1,
					borderColor: 'divider',
				}}
			>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label='basic tabs example'
					centered
				>
					<Tab label='Completados' {...a11yProps(0)} />
					<Tab label='Cancelados' {...a11yProps(1)} />
				</Tabs>
			</Box>
			<TabPanel value={value} index={0}>
				<List disablePadding>
					{orders
						?.filter((order) => order.status === 'done')
						.map((order) => (
							<OrderListItem key={order.id} order={order} isDisabled /> //* disabled for no interaction
						))}
				</List>
			</TabPanel>
			<TabPanel value={value} index={1}>
				{deletedData?.map((order) => (
					<OrderListItem key={order.id} order={order} isDisabled /> //* disabled for no interaction
				))}
			</TabPanel>
		</Box>
	);
}
